module.exports = __webpack_public_path__ + "img/Yadira Garcia.e061ef8e.jpg";